<template>
    <div class="card">
          <div class="card-header">
                <p class="card-header-title">
                    Brukerinformasjon
                </p>
            </div>
          <div class="card-content">
            
            <div class="content" v-if="authenticated">
                <p>Du er logget inn som: {{ `${profile.firstname} ${profile.lastname}` }}</p>

                <table class="table is-hover">
                  <tr>
                    <td>Epost</td>
                    <td>{{ profile.email }}</td>
                  </tr>
                  <tr>
                    <td>Firma</td>
                    <td>{{ company.name }}</td>
                  </tr>
                </table>

                <p><a @click="setShowCookiePolicyInfo()">Vis informasjon om bruk av informasjonskapsler (cookies) på denne siden</a></p>
            </div>
            <div class="content" v-if="!authenticated">
                <p>For å benytte funksjonalitet på denne siden må du logge inn. 
                    Benytt knapp i øvre høyre hjørne eller nedenfor</p>
            </div>

            </div>
            <footer class="card-footer" v-if="authenticated">
                <a class="card-footer-item" @click="logout()">Logg ut</a>
                <router-link to="changepassword" class="card-footer-item">Endre passord</router-link>
            </footer>
            <footer class="card-footer" v-if="!authenticated">
                <a class="card-footer-item" @click="login()">Logg inn</a>
                <router-link to="forgotpassword" class="card-footer-item">Glemt passord</router-link>
            </footer>
        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    computed: {
        ...mapGetters('auth', ['authenticated', 'profile', 'showCookiePolicyInfo']),
        ...mapGetters('customers', ['customerById']),
        company () {
            return this.$store.getters['customers/customerById'](this.profile.app_metadata.companyId) || {name:this.profile.app_metadata.companyId}
        }
    },
    methods: { 
        ...mapActions('customers', ['getCustomers']),
        ...mapActions('auth', ['login', 'logout', 'setShowCookiePolicyInfo'])
    },
    mounted () {
        if (this.authenticated)
            this.getCustomers()
    }
}
</script>
